import { useDropzone, type DropzoneState } from "react-dropzone";
import { ActorRefFrom } from "xstate";
import {
  acceptedExtensions,
  acceptedImageFiles,
} from "../utils/fileAcceptance";
import { ImagesMachineContext } from "../state/imagesMachine";

export function useImageDropzone(
  imagesMachine?: ActorRefFrom<typeof ImagesMachineContext.machine>
): DropzoneState {
  const defaultImagesMachine = ImagesMachineContext.useActorRef();
  const machine = imagesMachine || defaultImagesMachine;

  return useDropzone({
    accept: acceptedExtensions.images,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      machine.send({
        type: "ADD_FILES",
        files: acceptedImageFiles(acceptedFiles),
      });
    },
  });
}
